import Ch8Contact from '@/chapters/Ch8Contact';

export default function ContactPage() {
  return <Ch8Contact />;
}
